import { render, staticRenderFns } from "./parameterComponent.vue?vue&type=template&id=2bf39020&scoped=true&"
import script from "./parameterComponent.vue?vue&type=script&lang=js&"
export * from "./parameterComponent.vue?vue&type=script&lang=js&"
import style0 from "./parameterComponent.vue?vue&type=style&index=0&id=2bf39020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf39020",
  null
  
)

export default component.exports